export default __webpack_public_path__ + "static/media/banner-mobile.d27ee815.png";